module.exports = __webpack_public_path__ + "static/media/raiffeisen@2x.6419baaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/raiffeisen@2x.png
// module id = 612
// module chunks = 9